import React from "react";
import axios from "axios";
import ActiveStatusCell from "../utils/ActiveStatusCell"; // adjust path as needed

const getAuthHeaders = () => {
  const token = sessionStorage.getItem("token");
  return {
    Authorization: `Bearer ${token}`,
  };
};

const shouldSkipColumn = (key) =>
  ["id", "delete", "created", "updated", "modified", "logo", "workflow_status"].some((pattern) =>
    key.toLowerCase().includes(pattern)
  );

const isActiveColumn = (key) =>
  ["is_active", "active", "status", "is_feecategory_active"].some((pattern) =>
    key.toLowerCase().includes(pattern)
  );

const fetchTableData = async ({
  url,
  onEdit = () => {},
  onDelete = () => {},
  onExtraAction = null,
  setColumns,
  setRows,
  openViewSetter = null,
  customActionComponent = null,
  customColumns = [],
  useSno = true,
}) => {
  try {
    const res = await axios.get(url, {
      headers: getAuthHeaders(),
    });

    let data = [];
    if (Array.isArray(res.data)) {
      data = res.data; // PHP legacy
    } else if (res.data && Array.isArray(res.data.data)) {
      data = res.data.data; // Node.js API
    }

    if (!Array.isArray(data) || data.length === 0) {
      console.info("No data found");
      setColumns([]);
      setRows([]);
      return;
    }

    const dynamicColumns = Object.keys(data[0])
      .filter((key) => !shouldSkipColumn(key))
      .map((key) => ({
        Header: () => (
          <span style={{ fontSize: "13px", fontWeight: "bold" }}>
            {key.replace(/_/g, " ").replace(/\b\w/g, (l) => l.toUpperCase())}
          </span>
        ),
        accessor: key,
        ...(isActiveColumn(key) && { Cell: ActiveStatusCell }),
      }));

    const baseColumns = useSno
      ? [
          {
            Header: () => <span style={{ fontSize: "13px", fontWeight: "bold" }}>SNo</span>,
            accessor: "sno",
          },
        ]
      : [];

    const actionColumn = customActionComponent
      ? [
          {
            Header: () => <span style={{ fontSize: "13px", fontWeight: "bold" }}>Actions</span>,
            accessor: "actions",
            align: "center",
            disableSortBy: true,
          },
        ]
      : [];

    setColumns([...baseColumns, ...customColumns, ...dynamicColumns, ...actionColumn]);

    const formattedRows = data.map((row, index) => ({
      sno: index + 1,
      ...row,
      ...(customActionComponent && {
        actions: React.createElement(customActionComponent, {
          row,
          onEdit,
          onDelete,
          onExtraAction,
        }),
      }),
    }));

    setRows(formattedRows);
    if (openViewSetter) openViewSetter(true);
  } catch (err) {
    console.error("Error fetching table data:", err);
  }
};

export default fetchTableData;
